import React from "react";
import { View, StyleSheet, Text } from "@react-pdf/renderer";
import { config } from "./common/config";

const styles = StyleSheet.create({
  footer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    position: "absolute",
    fontFamily: config.fontFamily,
    fontSize: 11,
    bottom: 15,
    left: 50,
    right: 50,
    textAlign: "left",
    color: "gray",
    borderTopWidth: 1,
    borderTopColor: "#cccccc",
    paddingTop: 5,
  },
});

const Footer = () => (
  <View style={styles.footer} fixed>
    <Text>
      Documento gerado em{" "}
      {new Date().toLocaleString("pt-BR", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })}{" "}
      - Zaivu
    </Text>
    <Text
      fixed
      render={({ pageNumber, totalPages }) =>
        `Página ${pageNumber} de ${totalPages}`
      }
    />
  </View>
);

export default Footer;
